import styled from "styled-components"

import { formatPriceByLocale } from "utils/utils"

export default function PriceDetailInfo({ subTotalPrice, shippingPrice }) {
  return (
    <Section>
      <GridItem>
        <Label>상품 금액</Label>
        <Price>{subTotalPrice && `${formatPriceByLocale("ko", subTotalPrice)}원`}</Price>
      </GridItem>
      <GridItem>
        <Label>배송비</Label>
        <Price>
          {shippingPrice > 0 ? `${formatPriceByLocale("ko", shippingPrice)}원` : "무료배송"}
        </Price>
      </GridItem>
    </Section>
  )
}

const Section = styled.div`
  padding: calc(100vw * (23 / 375)) 0;
`

const GridItem = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: calc(100vw * (25 / 375));

  &:nth-last-child(1) {
    margin-bottom: 0;
  }
`

const Label = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  color: #4e4e4e;
`

const Price = styled.span`
  font-size: calc(100vw * (14 / 375));
  font-weight: 500;
  line-height: calc(100vw * (17 / 375));
  color: #121212;
`
